import React, { useEffect } from 'react'
import Order_Details_Card from '../order_details_card/Order_Details_Card'
import { useDispatch, useSelector } from 'react-redux';
import { getAllCancelledOrder } from '../../../../../features/order/orderSlice';
import { encodeId, formatNewDate } from '../../../../../utils/common';

const Cancelled = () => {

    const data = [
        {
            order_id: 75843,
            item_no: 1,
            price: 1200,
            date: "13th May | 03:28 pm",
            subtext: "Cancelled (15. May. 2025)"
        },
        {
            order_id: 989,
            item_no: 3,
            price: 1500,
            date: "15th May | 03:00 pm",
            subtext: "Cancelled (15. May. 2025)"
        },
        {
            order_id: 75843,
            item_no: 1,
            price: 1200,
            date: "13th May | 03:28 pm",
            subtext: "Cancelled (15. May. 2025)"
        },

    ]


    const dispatch = useDispatch();
    const cancelledOrders = useSelector(
        (state) => state.order.allCancelledOrders
    );
    useEffect(() => {
        dispatch(getAllCancelledOrder({ order_status_id: 6 }));
    }, [dispatch]);

    return (
        <section className='Cancelled Ordered'>
            {cancelledOrders?.data?.map((item) => {
                return (
                    <Order_Details_Card
                        type="cancelled"
                        data={item}
                        orderId={item?.Product_Order?.invoice_no || " "}
                        no_of_items={item?.no_of_item || "1"}
                        date={item?.Product_Order?.Order_History?.cancelledAt || new Date()}
                        price={item?.total_amount || "0"}
                        subtext={`Cancelled at ( ${formatNewDate(item?.Product_Order?.Order_History?.cancelledAt, "date")} )` || "Pending"}
                        // onClick={() => {
                        //     setShowCouponModal(true);
                        // }}
                        baseLike={`/cancelled-order-details/${encodeId(item?.id)}`}
                    />
                )
            })}

            <div className='no_data_main_div'>
                <p className='no_data_text'>No more orders to show</p>
            </div>

        </section>
    )
}

export default Cancelled
